module.exports = __webpack_public_path__ + "static/media/info.dbd9930c.svg";